/**
 * SmartdineNow API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { GeoLocation } from './geoLocation';
import { SmartDineImage } from './smartDineImage';

export interface RestaurantBranchEntity { 
    creator?: string;
    modifier?: string;
    createdAt?: Date;
    modifiedAt?: Date;
    restaurantBranchId?: string;
    restaurantBranchCode?: string;
    name?: string;
    description?: string;
    address?: string;
    city?: string;
    state?: string;
    country?: string;
    countryCode?: string;
    location?: GeoLocation;
    restaurantId?: string;
    restaurantBranchImages?: Array<SmartDineImage>;
    gstIN?: string;
    fssai?: string;
    emailId?: string;
    website?: string;
    contactNumber?: string;
    pincode?: string;
    allowedOrderTypes?: Array<RestaurantBranchEntity.AllowedOrderTypesEnum>;
    allowedPaymentPreferences?: Array<RestaurantBranchEntity.AllowedPaymentPreferencesEnum>;
}
export namespace RestaurantBranchEntity {
    export type AllowedOrderTypesEnum = 'DINE_IN' | 'DELIVERY' | 'TAKEAWAY';
    export const AllowedOrderTypesEnum = {
        DINEIN: 'DINE_IN' as AllowedOrderTypesEnum,
        DELIVERY: 'DELIVERY' as AllowedOrderTypesEnum,
        TAKEAWAY: 'TAKEAWAY' as AllowedOrderTypesEnum
    };
    export type AllowedPaymentPreferencesEnum = 'PAY_BY_ONLINE' | 'PAY_BY_CASH';
    export const AllowedPaymentPreferencesEnum = {
        ONLINE: 'PAY_BY_ONLINE' as AllowedPaymentPreferencesEnum,
        CASH: 'PAY_BY_CASH' as AllowedPaymentPreferencesEnum
    };
}